import enUS from "date-fns/locale/en-US";
import zhCN from "date-fns/locale/zh-CN";
import zhTW from "date-fns/locale/zh-TW";

export const flattenMessages = (nestedMessages, prefix = "") =>
  Object.keys(nestedMessages).reduce((messages, key) => {
    const acc = messages;
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === "string") {
      acc[prefixedKey] = value;
    } else {
      Object.assign(acc, flattenMessages(value, prefixedKey));
    }

    return acc;
  }, {});

export const IntlMappings = (displayUnauthorized) => {
  let language;
  if (localStorage.getItem("lang")) {
    language = localStorage.getItem("lang");
  } else if (!displayUnauthorized) {
    language = "zh-Hant";
  } else if (navigator.language === "zh-TW") {
    language = "zh-Hant";
  } else if (navigator.language === "zh-CN") {
    language = "zh-Hans";
  } else {
    language = "en";
  }
  return language;
};

export const handleFnsIntl = (language) => {
  const locales = { enUS, zhCN, zhTW };
  let res;
  switch (language) {
    case "zh-Hant":
      res = "zhTW";
      break;
    case "zh-Hans":
      res = "zhCN";
      break;
    default:
      res = "enUS";
      break;
  }
  return locales[res];
};
